import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-heading font-black text-background-200 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-accent-100">
          <i className="ri-error-warning-line text-accent-500 text-3xl"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-2">
          Strona nie została znaleziona
        </h1>
        <p className="text-sm text-foreground-600 mb-6 max-w-sm mx-auto">
          Przepraszamy, strona której szukasz nie istnieje lub została przeniesiona.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-accent-500 text-background-50 font-semibold px-6 py-3 rounded-full hover:bg-accent-600 transition-all text-sm whitespace-nowrap cursor-pointer"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-home-4-line text-sm"></i>
          </span>
          Powrót na stronę główną
        </Link>
      </div>
    </div>
  );
}